<template>
  <advanced-json-editor
    :json.sync="this.form.settings.contents"
    :height="640"
    @error="onError"
    @updated="onUpdated"
  ></advanced-json-editor>
</template>

<script>
import AdvancedJsonEditor from "./AdvancedJsonEditor";
import _ from "lodash";

export default {
  name: "FormDetailContents",
  components: {
    AdvancedJsonEditor,
  },
  props: {
    form: Object,
  },
  methods: {
    onError() {
      //TODO: show error
    },
    onUpdated(val) {
      this.form.settings.contents = _.cloneDeep(val);
    },
  },
};
</script>

<style scoped></style>
